/**
 * localStorage cache for chat list and Life Analysis charts.
 * Keys are per-user. Write-on-success only; background refresh keeps data fresh.
 */

const CHAT_SESSIONS_PREFIX = 'lj_chat_sessions_';
const CHART_PREFIX = 'lj_chart_';

export const CHART_KEYS = {
  moods: 'moods',
  attachment: 'attachment',
  topics: 'topics',
  triggers: 'triggers',
  roots: 'roots',
};

export function getChatSessionsCache(userId) {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(CHAT_SESSIONS_PREFIX + userId);
    if (raw == null) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function setChatSessionsCache(userId, data) {
  if (!userId || !Array.isArray(data)) return;
  try {
    localStorage.setItem(CHAT_SESSIONS_PREFIX + userId, JSON.stringify(data));
  } catch {
    // ignore quota or other storage errors
  }
}

export function getChartCache(chartKey, userId) {
  if (!chartKey || !userId) return null;
  try {
    const key = CHART_PREFIX + chartKey + '_' + userId;
    const raw = localStorage.getItem(key);
    if (raw == null) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setChartCache(chartKey, userId, data) {
  if (!chartKey || !userId) return;
  try {
    const key = CHART_PREFIX + chartKey + '_' + userId;
    localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // ignore quota or other storage errors
  }
}
